<div class="one" fxLayout="column" [formGroup]="MatterConveyancingDetailsForm">
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field
      appearance="outline"
      fxFlex="33"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.COOLINGOFFDATE),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.COOLINGOFFDATE),
      }"
    >
      <mat-label>Cooling Off Date</mat-label>
      <input
        (dateInput)="CommanDatePickerClick('input', $event, 'COOLINGOFFDATE')"
        matTooltip="{{ toolTipList ? toolTipList.COOLINGOFFDATE?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="COOLINGOFFDATETEXT"
        (dateChange)="CommanDatePickerClick('input', $event, 'COOLINGOFFDATE')"
        matInput
        name="CoolingOffDate"
        [matDatepicker]="CoolingOffDate"
      />
      <mat-datepicker-toggle matSuffix [for]="CoolingOffDate"></mat-datepicker-toggle>
      <mat-datepicker #CoolingOffDate></mat-datepicker>
      @if (testBool && toolTipList.COOLINGOFFDATE) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.COOLINGOFFDATE.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.COOLINGOFFDATE?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      fxFlex="34"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.CONTRACTLENGTHVALUE),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.CONTRACTLENGTHVALUE),
      }"
    >
      <mat-label>Contract Length</mat-label>
      <input
        matInput
        matTooltip="{{ toolTipList ? toolTipList.CONTRACTLENGTHVALUE?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="CONTRACTLENGTHVALUE"
      />
      @if (testBool && toolTipList.CONTRACTLENGTHVALUE) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.CONTRACTLENGTHVALUE.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList
                  ? $safeNavigationMigration(toolTipList?.CONTRACTLENGTHVALUE?.COPYVALUE)
                  : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      fxFlex="33"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.CONTRACTLENGTHPERIODTYPE),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.CONTRACTLENGTHPERIODTYPE),
      }"
    >
      <mat-select
        matTooltip="{{ toolTipList ? toolTipList.COURT?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="CONTRACTLENGTHPERIODTYPE"
      >
        <mat-option value="Days">Days</mat-option>
        <mat-option value="Weeks">Weeks</mat-option>
        <mat-option value="Months">Months</mat-option>
        <mat-option value="Years">Years</mat-option>
      </mat-select>
      @if (testBool && toolTipList.CONTRACTLENGTHPERIODTYPE) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.CONTRACTLENGTHPERIODTYPE.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList
                  ? $safeNavigationMigration(toolTipList?.CONTRACTLENGTHPERIODTYPE?.COPYVALUE)
                  : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field
      appearance="outline"
      fxFlex="33"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.UNCONDITIONALDATE),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.UNCONDITIONALDATE),
      }"
    >
      <mat-label>Unconditional Date</mat-label>
      <input
        (dateInput)="CommanDatePickerClick('input', $event, 'UNCONDITIONALDATE')"
        matTooltip="{{ toolTipList ? toolTipList.UNCONDITIONALDATE?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="UNCONDITIONALDATETEXT"
        (dateChange)="CommanDatePickerClick('input', $event, 'UNCONDITIONALDATE')"
        matInput
        name="UnconditionalDate"
        [matDatepicker]="UnconditionalDate"
      />
      <mat-datepicker-toggle matSuffix [for]="UnconditionalDate"></mat-datepicker-toggle>
      <mat-datepicker #UnconditionalDate></mat-datepicker>
      @if (testBool && toolTipList.UNCONDITIONALDATE) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.UNCONDITIONALDATE.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList
                  ? $safeNavigationMigration(toolTipList?.UNCONDITIONALDATE?.COPYVALUE)
                  : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>

    <mat-form-field
      appearance="outline"
      fxFlex="33"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.CONTRACTCOMPLETIONDATE),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.CONTRACTCOMPLETIONDATE),
      }"
    >
      <mat-label>Contract Completion Date</mat-label>
      <input
        (dateInput)="CommanDatePickerClick('input', $event, 'CONTRACTCOMPLETIONDATE')"
        matTooltip="{{ toolTipList ? toolTipList.CONTRACTCOMPLETIONDATE?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="CONTRACTCOMPLETIONDATETEXT"
        (dateChange)="CommanDatePickerClick('input', $event, 'CONTRACTCOMPLETIONDATE')"
        matInput
        name="ContractCompletionDate"
        [matDatepicker]="ContractCompletionDate"
      />
      <mat-datepicker-toggle matSuffix [for]="ContractCompletionDate"></mat-datepicker-toggle>
      <mat-datepicker #ContractCompletionDate></mat-datepicker>
      @if (testBool && toolTipList.CONTRACTCOMPLETIONDATE) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.CONTRACTCOMPLETIONDATE.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList
                  ? $safeNavigationMigration(toolTipList?.CONTRACTCOMPLETIONDATE?.COPYVALUE)
                  : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      fxFlex="33"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.CONTRACTCOMPLETIONOTHERDATE),
        'has-warning': $safeNavigationMigration(
          errorWarningData.Warning?.CONTRACTCOMPLETIONOTHERDATE
        ),
      }"
    >
      <mat-label>Contract Completion Other Date</mat-label>
      <input
        (dateInput)="CommanDatePickerClick('input', $event, 'CONTRACTCOMPLETIONOTHERDATE')"
        matTooltip="{{ toolTipList ? toolTipList.CONTRACTCOMPLETIONOTHERDATE?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="CONTRACTCOMPLETIONOTHERDATETEXT"
        (dateChange)="CommanDatePickerClick('input', $event, 'CONTRACTCOMPLETIONOTHERDATE')"
        matInput
        name="ContractCompletionOtherDate"
        [matDatepicker]="ContractCompletionOtherDate"
      />
      <mat-datepicker-toggle matSuffix [for]="ContractCompletionOtherDate"></mat-datepicker-toggle>
      <mat-datepicker #ContractCompletionOtherDate></mat-datepicker>
      @if (testBool && toolTipList.CONTRACTCOMPLETIONOTHERDATE) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.CONTRACTCOMPLETIONOTHERDATE.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList
                  ? $safeNavigationMigration(toolTipList?.CONTRACTCOMPLETIONOTHERDATE?.COPYVALUE)
                  : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field
      appearance="outline"
      fxFlex="50"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.AUCTIONDATE),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.AUCTIONDATE),
      }"
    >
      <mat-label>Auction Date</mat-label>
      <input
        (dateInput)="CommanDatePickerClick('input', $event, 'AUCTIONDATE')"
        matTooltip="{{ toolTipList ? toolTipList.AUCTIONDATE?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="AUCTIONDATETEXT"
        (dateChange)="CommanDatePickerClick('input', $event, 'AUCTIONDATE')"
        matInput
        name="AuctionDate"
        [matDatepicker]="AuctionDate"
      />
      <mat-datepicker-toggle matSuffix [for]="AuctionDate"></mat-datepicker-toggle>
      <mat-datepicker #AuctionDate></mat-datepicker>
      @if (testBool && toolTipList.AUCTIONDATE) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.AUCTIONDATE.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.AUCTIONDATE?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      fxFlex="50"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.FINALDATEFORNOTICETOCOMPLETE),
        'has-warning': $safeNavigationMigration(
          errorWarningData.Warning?.FINALDATEFORNOTICETOCOMPLETE
        ),
      }"
    >
      <mat-label>Final Date For Notice To Complete</mat-label>
      <input
        (dateInput)="CommanDatePickerClick('input', $event, 'FINALDATEFORNOTICETOCOMPLETE')"
        matTooltip="{{ toolTipList ? toolTipList.FINALDATEFORNOTICETOCOMPLETE?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="FINALDATEFORNOTICETOCOMPLETETEXT"
        (dateChange)="CommanDatePickerClick('input', $event, 'FINALDATEFORNOTICETOCOMPLETE')"
        matInput
        name="FinalDateForNoticeToComplete"
        [matDatepicker]="FinalDateForNoticeToComplete"
      />
      <mat-datepicker-toggle matSuffix [for]="FinalDateForNoticeToComplete"></mat-datepicker-toggle>
      <mat-datepicker #FinalDateForNoticeToComplete></mat-datepicker>
      @if (testBool && toolTipList.FINALDATEFORNOTICETOCOMPLETE) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.FINALDATEFORNOTICETOCOMPLETE.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList
                  ? $safeNavigationMigration(toolTipList?.FINALDATEFORNOTICETOCOMPLETE?.COPYVALUE)
                  : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-checkbox
      fxFlex="100"
      matTooltip="{{ toolTipList ? toolTipList.TRANSFERFEESEXCLUDED?.HOVER : '' }}"
      [matTooltipPosition]="toolTipPostion"
      formControlName="TRANSFERFEESEXCLUDED"
    >
      Transfer Fees Excluded
    </mat-checkbox>
  </div>
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field
      appearance="outline"
      fxFlex="33"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.DUPLICATEDOCUMENTS),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.DUPLICATEDOCUMENTS),
      }"
    >
      <mat-label>Duplicate Documents</mat-label>
      <input
        matInput
        matTooltip="{{ toolTipList ? toolTipList.DUPLICATEDOCUMENTS?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="DUPLICATEDOCUMENTS"
      />
      @if (testBool && toolTipList.DUPLICATEDOCUMENTS) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.DUPLICATEDOCUMENTS.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList
                  ? $safeNavigationMigration(toolTipList?.DUPLICATEDOCUMENTS?.COPYVALUE)
                  : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      fxFlex="34"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.DUPLICATETRANSFERS),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.DUPLICATETRANSFERS),
      }"
    >
      <mat-label>Duplicate Transfers</mat-label>
      <input
        matInput
        matTooltip="{{ toolTipList ? toolTipList.DUPLICATETRANSFERS?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="DUPLICATETRANSFERS"
      />
      @if (testBool && toolTipList.DUPLICATETRANSFERS) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.DUPLICATETRANSFERS.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList
                  ? $safeNavigationMigration(toolTipList?.DUPLICATETRANSFERS?.COPYVALUE)
                  : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      fxFlex="33"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.ENOSID),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.ENOSID),
      }"
    >
      <mat-label>eNOS Id</mat-label>
      <input
        matInput
        matTooltip="{{ toolTipList ? toolTipList.ENOSID?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="ENOSID"
      />
      @if (testBool && toolTipList.ENOSID) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.ENOSID.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.ENOSID?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutAlign="start center" fxGap="30px">
    <mat-checkbox
      matTooltip="{{ toolTipList?.TORRENSTITLE?.HOVER }}"
      [matTooltipPosition]="toolTipPostion"
      formControlName="TORRENSTITLE"
    >
      Torrens Title
    </mat-checkbox>
    &nbsp;&nbsp;

    <mat-checkbox
      matTooltip="{{ toolTipList?.COMMUNITYTITLE?.HOVER }}"
      [matTooltipPosition]="toolTipPostion"
      formControlName="COMMUNITYTITLE"
    >
      Community Title
    </mat-checkbox>
  </div>
</div>
